import React from 'react'
import { Modal, Button } from 'react-bootstrap'

const WarningModal = (props) => {
	return (
		<Modal 
			dialogClassName={props.dialogClassName || "modal-wide"} 
			show={props.show} 
			onHide={props.onHide ? () => props.onHide() : () => null}
		>
      <Modal.Header closeButton={props.onHide ? true : false}>
        {props.headerText}
      </Modal.Header>

			<Modal.Body>
        {props.bodyText}
      </Modal.Body>

			<Modal.Footer>
				{props.hideConfirmButton ?
          null
          :
          <Button onClick={props.onConfirm} variant="primary">
            {props.confirmText || 'Yes'}
          </Button>
        }

        {props.hideCancelButton ?
          null
          :
          <Button onClick={props.onCancel} variant="secondary">
            {props.cancelText || 'No'}
          </Button>
        }
			</Modal.Footer>
		</Modal>
	)
}

export default WarningModal